import AppHeader from '../AppHeader'

export default {
  name: 'moral-check',
  created () {
    this.search()
  },
  updated () {
  },
  data () {
    return {
      callbackFlag: false,
      startSlide: 0,
      slider: null,
      first: true,
      controlFlag: true,
      answerNum: 1,
      hlist: [],
      rightBtn: false,
      swiperOption: {
        init: true,
        initialSlide: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideNextTransitionStart: () => {
            this.answerNum += 1
          },
          slidePrevTransitionStart: () => {
            this.answerNum -= 1
          }
        }
      }
    }
  },
  computed: {
    moralResult () {
      return this.$store.getters.moralResult
    },
    moralDetails () {
      return this.$store.getters.moralDetails
    },
    moralLastCount () {
      return this.$store.getters.moralLastCount
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    totalNum() {
      return this.$store.getters.moralDetails.length
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  components: {
    AppHeader
  },
  methods: {
    onClickHelpModalShow: function () {
      var button = document.getElementById('helpModalButton')
      button.click() // モーダル表示 イベント発火
      $(".modal-backdrop")
    },
    search: function () {
      var self = this
      var data = {}
      var callback = function() {
        if (self.$route.params.id == 999) {
          if (self.moralLastCount) {
            if(self.moralLastCount == self.moralDetails.length) {
              self.$router.push({ path: '/moral_check_list/'})
            }
            self.startSlide = self.moralLastCount
            self.answerNum = self.moralLastCount
          }
        } else {
          self.controlFlag = false
          self.startSlide = self.$route.params.id
          self.answerNum = Number(self.$route.params.id)
        }
        self.swiperOption.initialSlide = self.startSlide
        self.callbackFlag = true
      }
      this.$store.dispatch('MORAL_GET',  {id: window.localStorage.getItem('user_id'), data: data, callback: callback})
    },
    answer: function (moralId, moralDetailId, answer, index) {
      var btn = document.activeElement
      btn.blur()
      var self = this
      var data = {
        'moral_id': moralId,
        'moral_detail_id': moralDetailId,
        'user_id': window.localStorage.getItem('user_id'),
        'answer': answer
      }
      var callback = function() {
        if (self.$route.params.id == 999) {
          if (index + 1 == self.moralDetails.length) {
            self.$router.push({ path: '/moral_check_list/'})
          }
          self.swiper.slideNext()
          self.moralDetails[index].attributes['answer'] = answer
        } else {
          self.$store.dispatch('MORAL_ALL_ANSWERED', {data: data})
          self.$router.push({ path: '/moral_check_list/'})
        }
      }
      this.$store.dispatch('MORAL_UPDATE', {id: moralId, data: data, callback: callback})
    },
    goMoralCheckList: function () {
      this.$router.push({ path: '/moral_check_list/'})
    },
    getAnswer: function (answer) {
      if (answer == 'yes') {
        return '-on-yes'
      } else if (answer == 'no') {
        return '-on-no'
      } else {
        return ''
      }
    },
    getAnswerYes: function (answer) {
      if (answer == 'yes') {
        return '-on'
      } else if (answer == 'no') {
        return '-off'
      } else {
        return ''
      }
    },
    getAnswerNo: function (answer) {
      if (answer == 'no') {
        return '-on'
      } else if (answer == 'yes') {
        return '-off'
      } else {
        return ''
      }
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/moral-check.js